import { ISaberisInitResponse, ISaberisUploadXmlResult, ISaberisDocumentStatusResult, ISaberisDocumentStatus, ISaberisResponse } from "helpers/interfaces";
import APIHelper from "../../helpers/APIHelper";
import WebResponse from "helpers/WebResponse";

export default class SaberisAPI {

    public static async GetLoginURL(): Promise<WebResponse<ISaberisInitResponse>> {
        const url: string = `api/saberis/init`;
        const response = await APIHelper.GetAsync<ISaberisInitResponse>(url, undefined, undefined, false);
        return response;
    }

    public static async SetTokens(accessToken: string, refreshToken: string): Promise<void> {
        const url: string = `api/saberis/settokens`;

        const body = {
            accessToken: accessToken,
            refreshToken: refreshToken
        }

        await APIHelper.PostAsync(url, undefined, body, false);
    }

    public static async UploadXml(oKey: number): Promise<WebResponse<ISaberisResponse<ISaberisUploadXmlResult>>> {
        const url: string = `api/saberis/upload`;
        const body = oKey;
        return await APIHelper.PostAsync<ISaberisResponse<ISaberisUploadXmlResult>>(url, undefined, body, false);
    }

    public static async QueryDocumentStatus(documentGuid: string): Promise<WebResponse<ISaberisResponse<ISaberisDocumentStatusResult>>> {
        const url: string = `api/saberis/${encodeURIComponent(documentGuid)}/documentstatus`;
        return await APIHelper.GetAsync<ISaberisResponse<ISaberisDocumentStatusResult>>(url, undefined, undefined, false);
    }

    public static async GetOriginalDocument(documentGuid: string): Promise<WebResponse<Blob | ISaberisResponse<number[]>>> {
        const url: string = `api/saberis/${encodeURIComponent(documentGuid)}/original`;
        return await APIHelper.GetAsync<Blob | ISaberisResponse<number[]>>(url, undefined, undefined, false, "application/xml");
    }

    public static async GetProcessedDocument(documentGuid: string): Promise<WebResponse<Blob | ISaberisResponse<number[]>>> {
        const url: string = `api/saberis/${encodeURIComponent(documentGuid)}`;
        return await APIHelper.GetAsync<Blob | ISaberisResponse<number[]>>(url, undefined, undefined, false, "application/xml");
    }

    public static async GetLatestQuoteDocumentStatus(oKey: number): Promise<ISaberisDocumentStatus> {
        const url: string = `api/saberis/${oKey}/status`;
        const response = await APIHelper.GetAsync<ISaberisDocumentStatus>(url);

        return response.Result;
    }

    public static async GetMaintenanceStatusList(oKeys: number[]): Promise<ISaberisDocumentStatus[]> {
        const url: string = `api/saberis/statusList`;
        const response = await APIHelper.PostAsync<ISaberisDocumentStatus[]>(url, undefined, oKeys);

        return response.Result;
    }

    public static async QueryDocumentStatuses(saberisDocumentStatuses: ISaberisDocumentStatus[]): Promise<WebResponse<ISaberisResponse<string[]>>> {
        const url: string = `api/saberis/refreshstatuses`;
        return await APIHelper.PostAsync<ISaberisResponse<string[]>>(url, undefined, saberisDocumentStatuses);
    }
}